<div class="labeled-input-container" style="padding-bottom: 10px;">
    <label [attr.for]="label" class="input-label" *ngIf="label">
        {{ label }}
        <span *ngIf="required" class="required-star">*</span>
      </label>
    <input
      matInput
      [type]="type"
      [placeholder]="placeholder"
      [value]="value"
      [required]="required"
      [disabled]="disabled"
      (input)="onInputChange($event)"
      class="input-field"
    />
</div>
  